exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".favoritesDialog {\n  width: 400px !important;\n  border-radius: 6px !important;\n  margin-top: 0 !important;\n}\n.favoritesDialog .dialogLoadingBlock {\n  font-size: 24px !important;\n}\n.favoritesDialog .el-dialog__header {\n  display: none;\n}\n.favoritesDialog .el-dialog__body {\n  padding: 0 !important;\n}\n", ""]);

// exports
